import { render, staticRenderFns } from "./CustomDetail.vue?vue&type=template&id=f06e2612&scoped=true"
import script from "./CustomDetail.vue?vue&type=script&lang=js"
export * from "./CustomDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomDetail.vue?vue&type=style&index=0&id=f06e2612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06e2612",
  null
  
)

export default component.exports